import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { canAccessBulkOrderOperations } from "../utils/bulkOperationsConfig";

interface IBulkOperationsRoute {
	component: JSX.Element;
}

// Stricter than AdminRoute: the bulk-operations module credits seller balances, so
// the Admin role alone is not enough — the user must also be on the per-country
// allowlist in utils/bulkOperationsConfig.ts. Header.tsx gates the nav entry on the
// same helper, so the link and the route can never disagree.
const BulkOperationsRoute = ({ component }: IBulkOperationsRoute) => {
	const { isLoggedIn } = useAuth();
	if (!isLoggedIn) {
		return <Navigate to={"/login"} replace />;
	}
	if (!canAccessBulkOrderOperations()) {
		return <Navigate to={"/no-access"} replace />;
	}

	const reqDoc = localStorage.getItem("requiresDocumentation");
	if (reqDoc === "true") {
		return <Navigate to={"/user-document-restore"} replace />;
	}
	return component;
};

export default BulkOperationsRoute;
